import React from "react";
import StaffListPage from "./StaffListPage";
import { TEACHER_DEPARTMENT } from "./happyschoolApi";

const HappySchoolTeachers = () => (
  <StaffListPage title="Giáo viên THPT" departmentFilter={TEACHER_DEPARTMENT} lockDepartment />
);

export default HappySchoolTeachers;
